import React from 'react';
import { SpaWrapper } from 'src/page/spaWrapper/SpaWrapper';

export function App() {
  // React Router v6: descendant <Routes> can't use absolute paths
  // that duplicate the parent route. Render SpaWrapper directly since
  // the parent route already matched /application/:applicationId?/*
  return <SpaWrapper />;
}
